import {
  Avatar,
  Button,
  Card,
  Grid,
  makeStyles,
  Backdrop,
  CircularProgress,
  Box,
  Drawer,
  AppBar,
  Typography,
  Toolbar,
  IconButton
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { PersonAdd, PersonAddDisabled } from "@material-ui/icons";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import CoachService from "../../../../../Coach/coach_service";
import User from "../../../../../../../Images/User.png";
import RightDrawer from "../../../../../../../Components/TemporarySidebar";
import { useHistory } from "react-router";
import CoachDetail from "../../../../../Coach/Shared/CoachDetail";
import CoachDetailsDrawer from "./CoachDetailsDrawer";
import moment from "moment";
import { useLocation } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
  noUserIcon: {
    fontSize: 35,
    color: `${theme.palette.primary.main}`,
    width: "100%",
  },
  noUserTitle: {
    fontSize: 14,
  },

  onlineCircle: {
    width: 11,
    height: 11,
    borderRadius: "50%",
    backgroundColor: "#21BA45",
    display: "inline-block",
  },
  onlineNextDateAvailableCircle: {
    width: 11,
    height: 11,
    borderRadius: "50%",
    backgroundColor: "#FFBF00",
    display: "inline-block",
  },
  onlineNotAvailableCircle: {
    width: 11,
    height: 11,
    borderRadius: "50%",
    backgroundColor: "#FF0000",
    display: "inline-block",
  },

  onlineAvailable: {
    marginLeft: 10,
    color: "#21BA45",
    fontSize: 16,
  },
  onlineNextDateAvailable: {
    marginLeft: 10,
    color: "#FFBF00",
    fontSize: 16,
  },
  onlineNotAvailable: {
    marginLeft: 10,
    color: "#FF0000",
    fontSize: 16,
  },
  btnBlue: {
    borderRadius: "25px",
    marginRight: "15px",
  },
  btnOrange: {
    borderRadius: "25px",
    marginRight: "15px",
  },
  btnGreen: {
    borderRadius: "25px",
    marginRight: "15px",
  },
  onlineid: {
    marginLeft: "6%",
  },
  userTitle: {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#4a4a4a",
    letterSpacing: ".5px",
  },
  userEmail: {
    justifyContent: "start",
    margin: "10px 0px",
    fontSize: "18px",
    color: "#707070",
  },
  deviderLine: {
    padding: "20px 30px",
  },
  personAdd: {

    fontSize: 30,
    borderRadius: 50,
    color: "#fff",
    backgroundColor: `${theme.palette.primary.main}`,
    padding: 10,
  },
}));


const selectedColor = ["#4089FC", "#EF7000", "#FFCC53", "#4AD991"]
function CommonSearch(props) {
  const {
    assignmentId,
    setSelectedCoaches,
    selectedCoaches,
    deleteCoachHandler,
    getSelectedCoaches,
    addSelectedCoach,
  } = props;
  const classes = useStyles();
  const [currentlyPickedCoachId, setCurrentlyPickedCoachId] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  // const [coachesCount, setCoachesCount] = useState(0);

  const [selectedCoachList, setSelectedCoachList] = useState([]);
  const history = useHistory();
  const [propsState, setPropsState] = useState(undefined);
  const location = useLocation();
  const { currentAssignment } = location?.state;
  const buttonTitleHandler = (id) => {
    if (selectedCoaches?.length > 0) {
      for (const coach of selectedCoaches) {
        // @ts-ignore
        if (coach?.partner_profile_id === id) {
          return "Remove from list";
        } else {
          return "Add coach to your list";
        }
      }
    } else {
      return "Add coach to your list";
    }
  };

  const shouldButtonShow = (id) => {
    // if (selectedCoaches?.length > 0) {
    //   for (const coach of selectedCoaches) {
    //     // @ts-ignore
    //     if (coach?.partner_profile_id === id) {
    //       return false;
    //     } else {
    //       return true;
    //     }
    //   }
    // } else {
    //   return true;
    // }
  return !selectedCoaches?.map((el)=>el.partner_profile_id)?.includes(id)
  };

  useEffect(() => {
    getSelectedCoaches();
    console.log(`I am selected coach list ${selectedCoachList}`);
  }, [currentlyPickedCoachId]);

  return (
    <>
      {Object.keys(props.searchResultArr).length > 0 &&
        props.searchResultArr[props.type].length > 0 ? (
        props.searchResultArr[props.type].map((e) => {
          console.log(e);
          const buttonTitle = buttonTitleHandler(e.id);
          const isBtnVisibile = shouldButtonShow(e.id);
          const fetchedDate = new Date(e.next_available_date).getTime();
          const currentDate = new Date().getTime();

          return (
            <Grid
              container
              direction="row"
              justify="center"
              style={{ border: "0px solid red" }}
              key={e.id}
            >
              <Grid item xs={12} style={{}}>
                <Card
                  variant="outlined"
                  style={{ marginTop: 30, borderRadius: 0, border: "2px solid #00000036" }}
                >
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    className={classes.deviderLine}
                  >
                    <Grid item xs={1} style={{ border: "0px solid blue" }}>
                      <Box>
                        <Avatar
                          alt="Avatar"
                          src={e?.profile_photo || User}
                          style={{ width: "65px", height: "65px" }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={9} style={{ border: "0px solid yellow" }}>
                      <Grid container direction="row" justify="start">
                        <Grid
                          item
                          xs={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <label className={classes.userTitle}>
                            {e.first_name + " " + e.last_name}
                          </label>
                          <div className={classes.onlineid}>
                            <div
                              className={
                                e.availability_status
                                  ? classes.onlineCircle
                                  : e.next_available_date &&
                                    fetchedDate > currentDate
                                    ? classes.onlineNextDateAvailableCircle
                                    : classes.onlineNotAvailableCircle
                              }
                            ></div>
                            <label
                              className={
                                e.availability_status
                                  ? classes.onlineAvailable
                                  : e.next_available_date &&
                                    fetchedDate > currentDate
                                    ? classes.onlineNextDateAvailable
                                    : classes.onlineNotAvailable
                              }
                            >
                              {e.availability_status
                                ? "Available Now"
                                : e.next_available_date &&
                                  fetchedDate > currentDate
                                  ? `Available from ${moment(
                                    e.next_available_date
                                  ).format("DD/MM/YYYY")}`
                                  : "Not Available"}
                            </label>
                          </div>
                        </Grid>
                        <Grid item xs={8} className={classes.userEmail}>
                          <label className={classes.userId}>
                            E-Mail: &nbsp;
                            <label style={{ textTransform: "lowercase" }}>
                              {e.email ? e.email : e.primary_email}
                            </label>
                          </label>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={2} style={{}}>

                      <Button
                        disableElevation
                        variant="contained"
                        color="primary"
                        style={{ float: "right" }}
                        className={classes.btnSearch}
                        onClick={(event) => {
                          setPropsState({
                            id: e.id,
                            coachType: currentAssignment?.service_type,
                            currentSelection: e,
                            selectedRole: currentAssignment?.service,
                          });
                        }}
                      >
                        View Profile
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    style={{
                      borderTop: "1px solid #d3d3d354",
                      padding: "15px 30px",
                      minHeight: "100px",
                      marginBottom: "-15px"
                    }}
                    spacing={1}
                  >
                    <Grid item xs={1}></Grid>
                    <Grid item xs={8} style={{ padding: "12px 0px 0px" }}>
                      {e.selected_attribute.map((item, index) => <Button
                        disableElevation
                        variant="contained"
                        style={{ backgroundColor: index <= 3 ? selectedColor[index] : selectedColor[index - 4], color: "#fff" }}
                        className={classes.btnBlue}
                      >
                        {item}
                      </Button>)}
                    </Grid>
                    <Grid item xs={3} style={{ textAlign: "end" }}>
                      {isBtnVisibile && (
                        <IconButton
                          aria-label="cart"
                          size="small"
                          onClick={() => {
                            buttonTitle === "Add coach to your list"
                              ? addSelectedCoach(e.id, e?.search_id, e?.user_id)
                              : deleteCoachHandler(e.id);
                          }}
                        >
                          {currentlyPickedCoachId === e.id ? (
                            <DeleteRoundedIcon
                              style={{ opacity: isLoading ? 0 : 1, }}
                              className={classes.personAdd}
                            />
                          ) : (
                            <PersonAdd
                              style={{ opacity: isLoading ? 0 : 1, }}
                              className={classes.personAdd}
                            />
                          )
                          }

                          {isLoading && currentlyPickedCoachId === e.id && (
                            <CircularProgress size={20} color="secondary" />
                          )}
                        </IconButton>
                      )}
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid >
          );
        })
      ) : (
        <Grid container direction="row" alignItems="center">
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Box my={3}>
              <PersonAddDisabled className={classes.noUserIcon} />
              <label className={classes.noUserTitle}>No results found</label>
            </Box>
          </Grid>
        </Grid>
      )}
      {
        propsState && (
          <Box mb={3}>
            <CoachDetailsDrawer
              style={{ width: "100%" }}
              anchor={"right"}
              open={Boolean(propsState)}
              onClose={() => setPropsState(undefined)}
            >
              <CoachDetail
                noHeader
                propsState={propsState}
                onClose={() => setPropsState(undefined)}
              />
            </CoachDetailsDrawer>
          </Box>
        )
      }
    </>
  );
}

export default CommonSearch;
